import { errorMessageFrom } from "../../../../../../../../utils/formErrors";
import React, { useState } from 'react';
import { Autocomplete, Box, Stack, CircularProgress, TextField } from '@mui/material';
import TopBar from '../../../../../../../../component/TopBar';
import ActiveBar from '../../../../../../../../component/PolicyNavbarUpdated';
import BtnSecondary from "../../../../../../../../component/SecondaryButton";
import BtnPrimary from "../../../../../../../../component/PrimaryButton";
import ErrorMsg from '../../../../../../../../component/ErrorMsg';
import FormField from '../../../../../../../../component/Formfield';
import { WizardCard, FormSection, FieldLabel, WizardActions } from '../../../../../../../../component/wizard';
import { useNavigate } from 'react-router';
import { getOrgShifts } from '../../../../../../../../services/globalData';
import { createShiftRotation } from '../../../../../../../../services/shiftRotation';
import { useNotify } from '../../../../../../../../component/NotificationProvider';
import { tokens } from '../../../../../../../../theme';

const RotationDetails = () => {
    const [apiCall, setApiCall] = useState(false);
    const navigate = useNavigate();
    const notify = useNotify();
    const shiftOptions = (getOrgShifts() || []).map((shift) => ({ value: shift?._id, name: shift?.name }));
    const [selectedShifts, setSelectedShifts] = useState([]);
    const [shiftRotationData, setShiftData] = useState({ name: "", description: "", shifts: [] });
    const [validationErrors, setValidationErrors] = useState({ name: "", shifts: "" });
    const [error, setError] = useState("");

    const handleShiftChange = (event, newValue) => {
      setSelectedShifts(newValue);
      handleChange('shifts', newValue.map((s) => s.value));
    };

    const handleNextClick = async () => {
        const errors = {};
        if (!shiftRotationData.name) errors.name = "Rotation name is required";
        if (!shiftRotationData.shifts || shiftRotationData.shifts.length < 2)
          errors.shifts = "Select at least two shifts to rotate between";
        if (Object.keys(errors).length > 0) { setValidationErrors(errors); return; }

        setApiCall(true);
        try {
            const res = await createShiftRotation(shiftRotationData);
            if (res.success) {
              notify.success("Shift rotation created");
              navigate("/app/shift-rotation/new/rotation-frequency", { state: { rotationId: res?.data?._id } });
            } else {
              setError(res.message);
              notify.error(errorMessageFrom(res, "Could not create shift rotation"));
            }
        } catch (error) {
            notify.error(error?.message || "Something went wrong");
        } finally {
            setApiCall(false);
        }
    };

    const handleChange = (field, value) => {
      setShiftData(prevState => ({ ...prevState, [field]: value }));
      setValidationErrors(prevState => ({ ...prevState, [field]: "" }));
      setError("");
    };

  return (
    <Box sx={{ width: "100%" }}>
        <TopBar MainHeading={"Shift Rotation"}
          breadcrumbs={[{ label: "Shift Rotation", href: "" }, { label: "Shift Rotation Details", href: "" }]} />
        <WizardCard>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
                <ActiveBar page="shift-rotation" active={["Shift"]} />
                <BtnSecondary to={"/app/shift-rotation/listing"} sx={{ borderRadius: "8px" }}>Back</BtnSecondary>
            </Stack>

            <FormSection title="Rotation details" description="Name the rotation and pick the shifts employees cycle through.">
                <FormField label="Rotation Name" type="text" value={shiftRotationData.name}
                    validation={validationErrors.name} onChange={(e) => handleChange('name', e.target.value)} />
                <FormField label="Description" type="text" value={shiftRotationData.description}
                    fullwidth row={3} onChange={(e) => handleChange('description', e.target.value)} />
                <Box sx={{ width: "100%", mt: "1rem" }}>
                    <FieldLabel>Shifts in rotation</FieldLabel>
                    <Autocomplete
                        multiple options={shiftOptions} getOptionLabel={(o) => o?.name || ""}
                        isOptionEqualToValue={(o, v) => o.value === v.value} size="small"
                        value={selectedShifts} onChange={handleShiftChange}
                        sx={{ '& .MuiInputBase-root': { borderRadius: '10px', minHeight: "2.75rem" } }}
                        renderInput={(params) => <TextField {...params} placeholder="Select shifts to rotate between" />}
                    />
                    <Box sx={{ fontSize: "0.8125rem", color: tokens.textMuted, mt: "0.5rem" }}>
                        Employees rotate through these shifts in order, advancing each rotation period.
                    </Box>
                    <ErrorMsg>{validationErrors.shifts}</ErrorMsg>
                </Box>
            </FormSection>

            <ErrorMsg>{error}</ErrorMsg>
            <WizardActions>
                <BtnPrimary onClick={handleNextClick} sx={{ borderRadius: "8px" }} disabled={apiCall}>
                    {apiCall ? <CircularProgress size={"1.25rem"} /> : "Next"}
                </BtnPrimary>
            </WizardActions>
        </WizardCard>
    </Box>
    )
}

export default RotationDetails;
